<template>
  <gg-select
    outlined
    label="Select Domain"
    hide-details
    v-model="domain"
    :items="domains"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'DomainSelect',
  computed: {
    ...mapGetters({
      serviceDomain: 'wizard/serviceDomain',
      domains: 'wizard/domains',
    }),
    domain: {
      get () {
        return this.serviceDomain
      },
      set (val) {
        this.setDomain(val)
      }
    }
  },
  methods: mapMutations({
    setDomain: 'wizard/SET_SERVICE_DOMAIN'
  })
}
</script>
